import React from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';

const menuData = [
  {
    title: 'Home',
    path: '/',
  },

  {
    title: 'About',
    path: '/about',
  },

  {
    title: 'Services',
    path: '#',

    iconClosed: <CgChevronLeft />,
    iconOpened: <CgChevronDown />,

    subNav: [
      {
        title: 'Services',
        path: '/services',
        cName: 'sub-nav',
      },
      {
        title: 'Services Details',
        path: '/services-details',
        cName: 'sub-nav',
      },
    ],
  },

  {
    title: 'Portfolio',
    path: '#',

    iconClosed: <CgChevronLeft />,
    iconOpened: <CgChevronDown />,

    subNav: [
      {
        title: 'Portfolio',
        path: '/portfolio',
        cName: 'sub-nav',
      },
      {
        title: 'Portfolio Details',
        path: '/portfolio-details',
        cName: 'sub-nav',
      },
    ],
  },

  {
    title: 'Blog',
    path: '#',

    iconClosed: <CgChevronLeft />,
    iconOpened: <CgChevronDown />,

    subNav: [
      {
        title: 'Blog Grid',
        path: '/blog',
        cName: 'sub-nav',
      },
      {
        title: 'Single Blog',
        path: '/single-blog',
        cName: 'sub-nav',
      },
    ],
  },

  {
    title: 'Contact',
    path: '/contact',
  },
];

export default menuData;
